import userModule from '../user/index'

import menu from './directive'

var mod = angular.module('SlotTrak.Menu', [userModule])
  .directive('menu', menu)


export default mod.name
